export enum OwnerFilters {
  All = 'all',
  Mine = 'mine'
}
